﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";


let lgMaxWidth = window.matchMedia("(max-width: 992px)");
let lgMinWidth = window.matchMedia("(min-width: 992px)");

const mainNavNode = document.querySelector('#mainNavbar')

export function initiateNavigation() {

    lgMaxWidthHandler(lgMaxWidth);
    lgMaxWidth.addListener(lgMaxWidthHandler);

    lgMinWidthHandler(lgMinWidth);
    lgMinWidth.addListener(lgMinWidthHandler);
}

//Initiate mobile nav
function mobileNav_Init() {
    let parent = $('#offcanvasMobileNav');
    let menus = parent.find('[data-menu-url]');
    menus.each(function () {
        let menu = $(this);
        let topLevelNav = $(menu).find('.top-level-nav');
        mobileNav_ajax(menu.data("menu-url"), "", function (data) {
            let htmlItems = '';
            for (let i = 0; i < data.length; i++) {
                if (data[i].hasChildren) {
                    htmlItems += `<div class="list-group-item list-group-item-action" data-id="${data[i].id}" data-url="${data[i].url}" data-title="${data[i].name}" data-has-children="true" role="button">${data[i].name}</div>`;
                } else {
                    htmlItems += `<a href="${data[i].url}" class="list-group-item list-group-item-action">${data[i].name}</a>`;
                }
            }
            topLevelNav.html(`<div class="list-group list-group-flush">${htmlItems}</div>`);
            topLevelNav.find('.list-group-item[data-has-children]').on('click', function (e) {
                e.preventDefault();
                let self = $(this);
                mobileNav_Forward(self);
            });
        });
    });

    $('#offcanvasMobileNav .offcanvas-title').on('click', mobileNav_Back);
}

//Destroy mobile nav
function mobileNav_Destroy(removeTopLevel = false) {
    let backButton = $('#offcanvasMobileNav .offcanvas-title');
    let elliotsLogo = $('#offcanvasMobileNav .offcanvas-logo');
    let otherPagers = $('#offcanvasMobileNav .offcanvas-pager[data-index]');
    let topLevelNav = $('#offcanvasMobileNav .top-level-nav');

    backButton.addClass('d-none');
    elliotsLogo.removeClass('d-none');
    topLevelNav.each(function () {
        var self = $(this);
        self.html('');
    });
    otherPagers.each(function () {
        var self = $(this);
        self.remove();
    });
}

function mobileNav_Forward(selector) {
    let menu = selector.closest('[data-menu-url]');
    let parentId = selector.data('id');
    let parentTitle = selector.data('title');
    let parentUrl = selector.data('url');
    let pager = menu.closest(".offcanvas-pager");
    mobileNav_ajax(menu.data('menu-url'), parentId, function (data) {
        var htmlItems = '';
        if (parentUrl && parentUrl.length) {
            var rendredParentTitle = menu.data('parent-title').replace("{0}", parentTitle)
            htmlItems += `<a href="${parentUrl}" class="list-group-item list-group-item-action">${rendredParentTitle}</a>`;
        }

        for (var i = 0; i < data.length; i++) {
            if (data[i].hasChildren) {
                htmlItems += `<div class="list-group-item list-group-item-action" data-id="${data[i].id}" data-url="${data[i].url}" data-title="${data[i].name}" data-has-children="true" role="button">${data[i].name}</div>`;
            } else {
                htmlItems += `<a href="${(data[i].url ?? "#")}" class="list-group-item list-group-item-action">${data[i].name}</a>`;
            }
        }
        let pagerIndex = $('#offcanvasMobileNav .offcanvas-pager[data-index]').length + 1;
        let navHtml = `<div class="card mb-4" data-menu-url="${menu.data('menu-url')}" data-parent-title="${menu.data('parent-title')}"><div class="card-header bg-dark p-2 text-white fs-13 fw-bolder">${parentTitle}</div><div class="card-body border-0 border-lg p-0 fs-13 fw-bolder"><div class="list-group list-group-flush">${htmlItems}</div></div></div>`;
        let htmlPager = `<div class="position-absolute offcanvas-pager hide bg-white" style="z-index:${pagerIndex}" data-index="${pagerIndex}">${navHtml}</div>`;

        pager.parent().append(htmlPager);
        $('#offcanvasMobileNav .offcanvas-pager[data-index]').last().find('.list-group-item[data-has-children]').on('click', function (e) {
            e.preventDefault();
            var self = $(this);
            mobileNav_Forward(self);
        });
        setTimeout(() => {
            $('#offcanvasMobileNav .offcanvas-pager[data-index].hide').removeClass('hide');
        }, 100);

        let backButton = $('#offcanvasMobileNav .offcanvas-title');
        let elliottsLogo = $('#offcanvasMobileNav .offcanvas-logo');
        backButton.removeClass('d-none');
        elliottsLogo.addClass('d-none');
    }, parent);
}

//Back to last level
function mobileNav_Back() {
    let pagers = $('#offcanvasMobileNav .offcanvas-pager[data-index]');
    let backButton = $('#offcanvasMobileNav .offcanvas-title');
    let elliottsLogo = $('#offcanvasMobileNav .offcanvas-logo');
    if (pagers.length) {
        pagers.last().addClass('hide');
        if (!$('#offcanvasMobileNav .offcanvas-pager[data-index]:not(.hide)').length) {
            backButton.addClass('d-none');
            elliottsLogo.removeClass('d-none');
        }
        setTimeout(() => {
            pagers.last().remove();
        }, 500);
    } else {
        backButton.addClass('d-none');
        elliottsLogo.removeClass('d-none');
    }
}

//Get data from server
function mobileNav_ajax(source, parentId = "", callBack = null, waiting = "") {
    loaderShow(waiting);
    source = `${source}?parentId=${parentId}`;
    $.ajax({
        url: source, type: 'GET', dataType: 'json', cache: true, success: function (data) {
            if (callBack && typeof callBack === 'function') {
                callBack(data);
            }
        }, error: function (error) {
            console.error(error);
        }, complete: function (event) {
            loaderHide(waiting);
        }
    });
}

function lgMaxWidthHandler(e) {
    if (e.matches) {
        mobileNav_Init(self);
    } else {
        mobileNav_Destroy(self);
    }
}

var timer;

function lgMinWidthHandler(e) {
    if (e.matches) {
        $(mainNavNode).find('.nav-item.dropdown').hover(function () {
            var el = $(this);
            timer = setTimeout(function (e) {
                let self = el;
                let toggleDropdown = self.children('.dropdown-toggle');
                let dropdownBackground = self.find('.dropdown-background');
                toggleDropdown.addClass('show');
                toggleDropdown.attr('aria-expanded', true);
                self.children('.dropdown-menu').addClass('show');
                dropdownBackground.on("click", function (e) {
                    if (e.target === e.currentTarget) {
                        closeOpenedDropdownMenu(self);
                    }
                });

                let x = window.scrollX;
                let y = window.scrollY;
                let header = $("header");
                let headerBottomPosition = header.height() + header.offset().top;
                dropdownBackground.css('top', headerBottomPosition - window.scrollY + 1);
                window.onscroll = function () {
                    window.scrollTo({
                        top: y, left: x, behavior: 'instant'
                    });
                };
            }, 275);

        }, function () {
            clearTimeout(timer);
            closeOpenedDropdownMenu($(this));
        });
        $(mainNavNode).find('.nav-item.dropdown > a.nav-link').on("click", function () {
            let self = $(this);
            let link = self.attr('href');
            if (link.length > 0 && link !== "#") {
                window.location.href = link;
            }
        });
    } else {
        $(mainNavNode).find('.nav-item.dropdown').off("mouseenter mouseleave")
    }

}

function closeOpenedDropdownMenu(self) {
    let dropdownBackground = self.find('.dropdown-background');
    let toggleDropdown = self.children('.dropdown-toggle');
    toggleDropdown.removeClass('show');
    toggleDropdown.attr('aria-expanded', false);
    self.children('.dropdown-menu').removeClass('show');
    dropdownBackground.off("click");

    window.onscroll = function () {
    };
}